import {lazy} from "react";

export const VipAsync = lazy(() => import('../ui/VIP'))
